/* Recomputes bundle tier prices when the shopper changes variant.

   Needed because this theme updates the product price client-side rather than
   re-rendering the section, so Liquid-computed tier prices would otherwise stay
   pinned to whichever variant happened to be selected on page load. That is
   harmless when every variant costs the same, and wrong when they don't
   (Dream Restore Pro spans $199 to $418.59).

   Mirrors the Liquid exactly: discount comes from the cart-discount tiers applied
   to each tier's PRE-discount subtotal. If anything here throws, the server-rendered
   prices simply remain - the page never ends up worse than without this file. */
(function () {
  'use strict';

  function parseMoneyFormat(cents, format) {
    function withDelimiters(n, precision, thousands, decimal) {
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? head + decimal + parts[1] : head;
    }
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = (format || '${{amount}}').match(placeholder);
    var token = match ? match[1] : 'amount';

    switch (token) {
      case 'amount': value = withDelimiters(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ' '); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }
    return (format || '${{amount}}').replace(placeholder, value);
  }

  /* Liquid's money_without_trailing_zeros: drop ".00" on whole amounts. */
  function money(cents, format) {
    var out = parseMoneyFormat(cents, format);
    if (cents % 100 === 0) out = out.replace(/([.,])00(?!\d)/, '');
    return out;
  }

  function tierDiscountCents(subtotalCents, tiers, applies) {
    if (!applies || !tiers) return 0;
    var best = 0;
    tiers.split(',').forEach(function (pair) {
      var kv = pair.trim().split(':');
      var threshold = parseFloat(kv[0]);
      var amount = parseFloat(kv[1]);
      if (isNaN(threshold) || isNaN(amount)) return;
      if (subtotalCents / 100 >= threshold && amount > best) best = amount;
    });
    return Math.round(best * 100);
  }

  /* Same single-token precedence as snippets/text-with-price.liquid */
  var TOKENS = ['price', 'compare_price', 'amount_saved', 'amount_saved_rounded', 'price_each', 'compare_price_each'];

  function render(tpl, vals, format) {
    if (!tpl) return '';
    var out = tpl.replace(/\[quantity\]/g, vals.quantity);
    for (var i = 0; i < TOKENS.length; i++) {
      var t = '[' + TOKENS[i] + ']';
      if (out.indexOf(t) !== -1) {
        return out.split(t).join('<span>' + money(vals[TOKENS[i]], format) + '</span>');
      }
    }
    return out;
  }

  function update(root) {
    var cfgEl = root.querySelector('.qbc__config');
    if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);

    var form = root.closest('form[action*="/cart/add"]');
    if (!form) {
      var anyInput = root.querySelector('.qbc__input[form]');
      if (anyInput) form = document.getElementById(anyInput.getAttribute('form'));
    }
    var idInput = form && form.querySelector('[name="id"]');
    var variant = idInput && cfg.variants[String(idInput.value)];
    if (!variant) return;

    var price = variant.p;
    var comparePrice = variant.c && variant.c > price ? variant.c : price;

    root.querySelectorAll('.qbc__card').forEach(function (card) {
      var quantity = parseInt(card.dataset.quantity, 10) || 1;
      var pct = parseFloat(card.dataset.pct) || 0;
      var basis = card.dataset.cmpBasis === 'compare_price' ? comparePrice : price;

      var subtotal = Math.round(price * quantity * ((100 - pct) / 100));
      var discount = tierDiscountCents(price * quantity, cfg.tiers, cfg.discountApplies);
      if (!cfg.tiers) discount = Math.round((parseFloat(card.dataset.fixed) || 0) * 100);
      var optionPrice = subtotal - discount;
      var optionCompare = basis * quantity;

      var vals = {
        quantity: quantity,
        price: optionPrice,
        compare_price: optionCompare,
        amount_saved: optionCompare - optionPrice,
        amount_saved_rounded: Math.round((optionCompare - optionPrice) / 100) * 100,
        price_each: Math.floor(optionPrice / quantity),
        compare_price_each: Math.floor(optionCompare / quantity)
      };

      card.querySelectorAll('[data-qbc-tpl]').forEach(function (el) {
        var html = render(el.dataset.qbcTpl, vals, cfg.moneyFormat);
        /* keep the leading numeral bold, matching the Liquid */
        if (el.classList.contains('qbc__units')) {
          html = html.replace(/^(\s*)(\d[\d.,]*)/, '$1<b>$2</b>');
        }
        el.innerHTML = html;
      });

      /* savings = price reduction + retail value of that tier's gifts */
      var saveEl = card.querySelector('.qbc__save');
      if (saveEl) {
        var giftValue = parseInt(saveEl.dataset.giftValue, 10) || 0;
        var productSaving = optionCompare - optionPrice;
        var totalSaving = productSaving + giftValue;
        saveEl.innerHTML = 'You save ' + money(totalSaving, cfg.moneyFormat);
        saveEl.style.display = totalSaving > 0 ? '' : 'none';
        var noteEl = card.querySelector('.qbc__save-note');
        if (noteEl) {
          noteEl.innerHTML = money(productSaving, cfg.moneyFormat) + ' off · ' +
                             money(giftValue, cfg.moneyFormat) + ' in gifts';
          noteEl.style.display = giftValue > 0 && totalSaving > 0 ? '' : 'none';
        }
      }

      /* strikethrough only when there is a real saving, matching the Liquid */
      var cmp = card.querySelector('.qbc__compare');
      if (cmp) cmp.style.display = optionCompare > optionPrice ? '' : 'none';
    });
  }

  function bind(root) {
    if (root.dataset.qbcPriceBound === '1') return;
    root.dataset.qbcPriceBound = '1';
    var run = function () { try { update(root); } catch (e) { /* keep server-rendered prices */ } };
    document.addEventListener('change', function () { setTimeout(run, 0); }, true);
    run();
  }

  function boot() { document.querySelectorAll('.qbc').forEach(bind); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
